import { useColorScheme } from '../../theme'
import { isDevelopmentEnvironment } from './is-development-environment'
import { type Environment } from './type-environment'

export type EnvironmentBackgroundColor = {
  bgColor: 'components.pageHeader.default' | 'components.pageHeader.accept' | 'components.pageHeader.test'
  color: `components.pageHeader.color.${'contrast' | 'default'}`
  fill: 'light' | 'dark'
}

/**
 * Do we need to have a background color to understand which environment we are on
 */
export const useEnvironmentBackgroundColor = (environment?: Environment): EnvironmentBackgroundColor => {
  const { activePaletteMode } = useColorScheme()

  // we only exclude on test and accept environment ('test' & 'accept')
  if (environment && isDevelopmentEnvironment(environment)) {
    return {
      // WHY
      bgColor: `components.pageHeader.${environment === 'test' ? 'test' : 'accept'}`,
      color: 'components.pageHeader.color.contrast',
      fill: 'light',
    }
  }

  return {
    bgColor: 'components.pageHeader.default',
    fill: activePaletteMode === 'dark' ? 'light' : 'dark',
    color: 'components.pageHeader.color.default',
  }
}
